import { getCsrfCookie } from "@Light/services/apiHelpers";
import { createLightApi } from "@Light/services/light";
import { fetchBaseQuery } from "@reduxjs/toolkit/query";

export const baseQuery = fetchBaseQuery({
  baseUrl: "/api/v1/account",
  prepareHeaders: (headers) => {
    const csrfToken = getCsrfCookie();
    if (csrfToken) {
      headers.set("X-CSRFToken", csrfToken);
    }
    return headers;
  },
});

export const light = createLightApi(baseQuery);
